import { render, staticRenderFns } from "./dataLabel.vue?vue&type=template&id=705252d5"
import script from "./dataLabel.vue?vue&type=script&lang=js"
export * from "./dataLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports